import api from "./Api";

class ConsultaAvancadaService {
  GetConsultaAvancada(payload) {
    return api.get("/v1/consultaAvancada/" + payload).then((response) => {
      return response.data;
    });
  }

  PostConsultaAvancada(payload) {
    return api.post("/v1/consultaAvancada/", payload).then((response) => {
      return response.data;
    });
  }

  PutConsultaAvancada(payload) {
    return api.put("/v1/consultaAvancada/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteConsultaAvancada(payload) {
    return api.delete("/v1/consultaAvancada/" + payload).then((response) => {
      return response.data;
    });
  }

  GetConsultaAvancadaOData(payload) {
    return api.get("/OData/ConsultaAvancada" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ConsultaAvancadaService();
